import { MenuItem } from "./menu-item.js";
import { styles } from "./menu-item.styles.js";
import { template } from "./menu-item.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-menu-item>
 */
export const definition = MenuItem.compose({
    name: `${DesignSystem.prefix}-menu-item`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
definition.define(DesignSystem.registry);
//# sourceMappingURL=menu-item.definition.js.map